<template>

<app-table-cell class="time" :border="border">

	<div class="time-slot" v-for="(slot, index) in slots" :key="index">{{ slot.time }}</div>

</app-table-cell>

</template>

<script>

export default {

	props: ['border', 'day', 'space', 'event', 'start', 'end', 'times'],

    computed: {
    
        slots: function() {
        
            var slots = {}

            this.$_.each(this.times, function(time, value) {
            
                if (value >= this.start && value <= this.end) {

                    slots[value] = {
                        time: (time.indexOf(':30') === -1) ? time.replace(':00', '') : ''
                    }
                
                }
            
            }.bind(this))

            return slots
        
        }
    
    }

}

</script>

<style scoped>

.time {
    display: grid;
    flex-direction: row;
    height: calc(100% - 1);;
    text-align: center;
    margin-bottom: 1px;
    font-size: 13px;
    padding: 0px!important;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    grid-template-rows: 1fr;
}

.time-slot {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.time > div:before {
    display: block;
    content: '';
    position: absolute;
    width: 2px;
    bottom: 0px;
    height: 4px;
    background-color: #ccc;
    left: 50%;
    margin-left: -1px;
}

</style>
